var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupServerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.391602,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#E1E9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8887 39.2801C24.8887 40.9467 26.222 42.3912 27.9998 42.3912C29.7776 42.3912 31.1109 41.0578 31.1109 39.2801C31.1109 37.5023 29.6664 36.1689 27.9998 36.1689C26.3331 36.1689 24.8887 37.5023 24.8887 39.2801ZM29.3331 39.2801C29.3331 40.0578 28.6664 40.6134 27.9998 40.6134C27.3331 40.6134 26.6664 39.9467 26.6664 39.2801C26.6664 38.6134 27.3331 37.9467 27.9998 37.9467C28.6664 37.9467 29.3331 38.5023 29.3331 39.2801Z",
    fill: "#46649E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4453 31.7246H33.5564V33.5024H22.4453V31.7246Z",
    fill: "#46649E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6673 20.0585C34.5562 19.8363 34.4451 19.7252 34.334 19.5029H21.334V21.2807H34.6673V20.0585Z",
    fill: "#46649E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 15.0586V16.8364H33.2229C33.1118 16.2808 33.0007 15.6141 33.0007 15.0586H21.334Z",
    fill: "#46649E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8887 22.0587V43.9476H19.1109V12.8365H33.3331C33.5553 12.0587 33.8887 11.2809 34.3331 10.6143H18.5553C17.6664 10.6143 16.8887 11.392 16.8887 12.2809V46.1698H39.1109V23.0587C38.3331 22.8365 37.5553 22.5031 36.8887 22.0587Z",
    fill: "#46649E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3329 20.614C44.4011 20.614 46.8885 18.1267 46.8885 15.0585C46.8885 11.9902 44.4011 9.50293 41.3329 9.50293C38.2647 9.50293 35.7773 11.9902 35.7773 15.0585C35.7773 18.1267 38.2647 20.614 41.3329 20.614Z",
    fill: "#46649E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupServerIcon);
export default __webpack_public_path__ + "static/media/GroupServerIcon.43bf8f5479aad2b72c07964cea2f55f5.svg";
export { ForwardRef as ReactComponent };